import { useState, useContext } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  TextField,
  DialogActions,
  DialogContent,
} from "@mui/material";
import ResponsiveDialog from "../UI/ResponsiveDialog";
import { useMutation } from "@apollo/client";
import { LOGIN } from "../../GraphQL/Login";
import { LoginContext } from "./LoginContext";

const LoginDialog = (props) => {
  const [credentials, setCredentials] = useState("");
  const [, setAuth] = useContext(LoginContext);

  function decodeAuth(token) {
    try {
      const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      const payload = JSON.parse(atob(base64));
      return {
        loggedIn: true,
        userId: payload.userId ?? payload.id ?? null,
        role: payload.role ?? payload.roles ?? null,
      };
    } catch {
      return { loggedIn: true, userId: null, role: null };
    }
  }

  const [login, { loading, error }] = useMutation(LOGIN, {
    variables: {
      username: credentials.username,
      password: credentials.password,
    },
    onCompleted: (response) => {
      const token = response.login.token;
      localStorage.setItem("token", token);
      setAuth(decodeAuth(token));
      props.setOpen(false);
    },
  });

  return (
    <div>
      <ResponsiveDialog
        open={props.open}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            login();
          } else if (e.key === "Escape") {
            props.setOpen(false);
          }
        }}
        title="Login"
        onClose={() => props.setOpen(false)}
      >
        <DialogContent>
          <TextField
            data-testid="username"
            autoFocus
            margin="dense"
            id="username"
            label="Username"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e) => {
              setCredentials({ ...credentials, username: e.target.value });
            }}
            InputProps={{ inputProps: { maxLength: 50 } }}
          />
          <TextField
            data-testid="password"
            margin="dense"
            id="password"
            label="Password"
            type="password"
            fullWidth
            variant="standard"
            onChange={(e) => {
              setCredentials({ ...credentials, password: e.target.value });
            }}
            InputProps={{ inputProps: { maxLength: 50 } }}
          />
        </DialogContent>
        {error && (
          <Alert data-testid="errorDialog" severity="error" sx={{ mx: 2, mb: 1 }}>
            {error.message}
          </Alert>
        )}
        <DialogActions>
          <Button
            data-testid="login"
            variant="contained"
            onClick={() => login()}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "inherit" }} />
            ) : (
              "Login"
            )}
          </Button>
          <Button onClick={() => props.setOpen(false)}>Cancel</Button>
        </DialogActions>
      </ResponsiveDialog>
    </div>
  );
};

export default LoginDialog;
